import { PLATFORM_LEGAL_CORPORATION_LABEL } from 'services/api/constants';
import { useIntlByKey } from 'services/i18n/hooks/useIntlByKey';

export const useSubscriptionRequestPageTitleIntl = (): string => {
  const subscriptionRequestFormIntl = useIntlByKey('subscription-request.form');

  return subscriptionRequestFormIntl('title', {
    legalCorporationLabel: PLATFORM_LEGAL_CORPORATION_LABEL,
  });
};
